import request from '../utils/request';

const buyingPostAuditQueueApi = {
  // 分页查询审核队列
  pageAuditQueues: (params = {}) => {
    return request.post('/buying-post-audit-queue/page', {
      page: 1,
      pageSize: 10,
      ...params
    });
  },

  // 获取审核队列详情
  getAuditQueueDetail: (id) => {
    return request.get(`/buying-post-audit-queue/${id}`);
  },

  // 审核求购帖
  auditBuyingPostQueue: (id, data) => {
    return request.put(`/buying-post-audit-queue/audit/${id}`, data);
  },

  // 删除审核队列
  deleteAuditQueue: (id) => {
    return request.delete(`/buying-post-audit-queue/${id}`);
  }
};

export default buyingPostAuditQueueApi;
